import ThumbnailCard from '../common/ThumbnailCard';
import './SequencingThumbnail.scss';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  sequenceCards: [],
  responseCards: [],
  isSmallThumbnail: false,
};

const SequencingThumbnail = (p) => {
  const { sequenceCards, responseCards, isSmallThumbnail } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className={`sequencing-thumbnail ${isSmallThumbnail ? 'small-thumbnail' : ''}`}>
      <div className='question-area'>
        {sequenceCards.map((sequenceCard) => (
          <ThumbnailCard
            key={`sequence-card-${sequenceCard.key}`}
            image={sequenceCard.image}
            text={sequenceCard.text}
            isSmallThumbnail={isSmallThumbnail}
            cardKey={isSmallThumbnail ? null : sequenceCard.key}
            className={`${isSmallThumbnail ? 'thumbnail-card-small' : ''}`}
          />
        ))}
      </div>
      <div className='answer-area'>
        {responseCards.map((responseCard, index) => (
          <ThumbnailCard
            key={`sequence-card-${responseCard.key}-${index}`}
            image={responseCard.image}
            text={responseCard.text}
            isSmallThumbnail={isSmallThumbnail}
            className={`${isSmallThumbnail ? 'thumbnail-card-small' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default SequencingThumbnail;
